export default {
  data: () => ({
    translations: {
      title: {
        el: 'Συναλλαγές & Παραγγελίες',
        en: 'Transactions & Orders',
        it: 'Transazioni e ordini',
      },
      info: {
        el: "'Ολες οι συναλλαγές και παραγγελίες του καταστήματος σας μαζί σε ένα μέρος. Διαχειριστείτε τις online πληρωμές και παραγγελίες, επιβεβαιώστε ή επιστρέψτε πληρωμές εύκολα",
        en: `All the payments and orders of your store are collected
                     in 1 place. Manage your online payments or online
                     ordersfrom 1 place, verify or refund easily`,
        it: 'Tutti i pagamenti e gli ordini del tuo negozio vengono raccolti in posto. Gestisci i tuoi pagamenti online o ordini online da 1 posto, verifica o rimborsa facilmente',
      },
      fundClosureHover: {
        el: 'Κάντε κλικ για λήψη της αναφοράς online συναλλαγών. Το χρονικό πλαίσιο θα είναι από την προηγούμενη λήψη έως τώρα.',
        en: 'Click to download the online transactions report. The timeframe will be from the previous download until now.',
        it: 'Fare clic per scaricare il report delle transazioni online. Il lasso di tempo sarà dal download precedente fino ad ora.',
      },
      last_z: {
        el: 'Κλείσιμο Ταμείου (Z)',
        en: 'Fund Closure (Z)',
        it: 'Chiusura del fondo (Z)',
      },
      last_z_download: {
        el: 'Λήψη Αρχείου (Z)',
        en: 'Download File (Z)',
        it: 'Scarica File (Z)',
      },
      settings: {
        el: 'Ρυθμίσεις ',
        en: 'Settings',
        it: 'Impostazioni',
      },
      user: {
        el: 'Χρήστης',
        en: 'User',
        it: 'Utente',
      },
      points: {
        el: 'Πόντοι',
        en: 'Points',
        it: 'Punti',
      },
      totalAmount: {
        el: 'Τελικό Ποσό',
        en: 'Total Amount',
        it: 'Importo totale',
      },
      totalPrice: {
        el: 'Συνολική τιμή',
        en: 'Total Price',
        it: 'Prezzo totale',
      },
      quantity: {
        el: 'Ποσότητα',
        en: 'Quantity',
        it: 'Quantità',
      },
      deliveryFee: {
        el: 'Κόστος Παράδοσης',
        en: 'Delivery Fee',
        it: 'Tassa di consegna',
      },
      delivery: {
        el: 'Παράδοση',
        en: 'Delivery',
        it: 'Consegna',
      },
      date: {
        el: 'Ημερομηνία',
        en: 'Date',
        it: 'Data',
      },
      status: {
        el: 'Κατάσταση',
        en: 'Status',
        it: 'Stato',
      },
      showDetails: {
        el: 'Λεπτομέρειες',
        en: 'View',
        it: 'Visualizzazione',
      },
      cash: {
        el: 'Μετρητά',
        en: 'Cash',
        it: 'Contanti',
      },
      actions: {
        el: 'Ενέργειες',
        en: 'Actions',
        it: 'Azioni',
      },
      noData: {
        el: 'Δεν υπάρχουν δεδομένα',
        en: 'No data available',
        it: 'Nessun dato disponibile',
      },
      deliveryDetails: {
        el: 'Delivery',
        en: 'Delivery',
        it: 'Delivery',
      },
      pickupFromStore: {
        el: 'Pickup',
        en: 'Pickup',
        it: 'Pickup',
      },
      clearer: {
        el: 'Τράπεζα',
        en: 'Bank',
        it: 'Banca',
      },
      verified: {
        el: 'Επιβεβαιωμένη',
        en: 'Verified',
        it: 'Verificato',
      },
      refunded: {
        el: 'Επιστροφή',
        en: 'Refunded',
        it: 'Refunded',
      },
      dailyRevenueTitle: {
        el: 'Ημερίσιος Τζίρος μέσω ',
        en: 'Daily Revenue via ',
        it: 'Daily Revenue via ',
      },
      dailyRevenueDescription: {
        el: 'από online πληρωμές, τελευτείες 24 ώρες',
        en: 'from online payments, last 24 hours',
        it: 'from online payments, last 24 hours',
      },
      paginationText: {
        el: 'από',
        en: 'of',
        it: 'di',
      },
      cancelTransaction: {
        el: 'Ακύρωση Συναλαγής',
        en: 'Cancel Transaction',
        it: 'Annulla transazione',
      },
      cancel: {
        el: 'X',
        en: 'X',
        it: 'X',
      },
      productName: {
        el: 'Όνομα Προϊόντος',
        en: 'Product Name',
        it: 'Nome del Prodotto',
      },
      verify: {
        el: 'Επιβεβαίωση',
        en: 'Verify',
        it: 'Verificare',
      },
      refund: {
        el: 'Επιστροφή',
        en: 'Refund',
        it: 'Rimborso',
      },
      store: {
        el: 'Κατάστημα',
        en: 'Store',
        it: 'Negozio',
      },
      transactionDetails: {
        el: 'Στοιχεία Συναλλαγής',
        en: 'Transaction Details',
        it: 'Dettagli della transazione',
      },
      customerDetails: {
        el: 'Στοιχεία Πελάτη',
        en: 'Customer Details',
        it: 'Dettagli del cliente',
      },

      startDate: {
        el: 'Από Ημερ/νία',
        en: 'Start Date',
        it: 'Da Data',
      },

      endDate: {
        el: 'Μέχρι Ημερ/νία',
        en: 'End Date',
        it: 'Fino a Data',
      },
      filterStatus: {
        el: 'Φίλτρο Κατάστασης',
        en: 'Filter By Status',
        it: 'Filtra per stato',
      },
      filterType: {
        el: 'Τύπος Συναλλαγής',
        en: 'Filter By Type',
        it: 'Filtra per Tipo ',
      },
      orders: {
        el: 'Παραγγελίες',
        en: 'Orders',
        it: 'Ordini',
      },
      reason: {
        el: 'Αιτιολογία',
        en: 'Reason',
        it: 'Motivo',
      },
    },
  }),
};
